import { render } from "./ReservacionesNew.vue?vue&type=template&id=274ff494&scoped=true"
import script from "./ReservacionesNew.vue?vue&type=script&lang=js"
export * from "./ReservacionesNew.vue?vue&type=script&lang=js"

import "./ReservacionesNew.vue?vue&type=style&index=0&id=274ff494&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274ff494"]])

export default __exports__